import { type M365ChatContainerProps } from './components/M365ChatContainer';
import type * as lazyIndex from './lazyIndex';
import {
    type LazyComponent,
    LazyModule,
    createLazyComponent,
    registerLazyOrchestrator,
} from 'owa-bundling';
import { onCopilotChatDrawerClosed } from 'owa-copilot-chat-drawer-store';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "SidepaneBizchat" */ './lazyIndex'),
    { name: 'SidepaneBizchat' }
);

export const M365ChatContainer: LazyComponent<M365ChatContainerProps, unknown, void> =
    createLazyComponent(lazyModule, m => m.M365ChatContainer);

registerLazyOrchestrator(
    onCopilotChatDrawerClosed,
    lazyModule,
    m => m.onCopilotChatDrawerClosedOrchestrator
);
